// extracted by mini-css-extract-plugin
module.exports = {"boldText":"styles_boldText__3unL3"};